import { Loading } from 'element-ui';
// Loading 中的配置项
const loadingOptions = {
  text: '努力加载中...'
}

let loadingInstance;
class LoadingEvent {
  show() {
    loadingInstance = Loading.service(loadingOptions)
  }
  hidden() {
    loadingInstance.close()
  }
}
export default new LoadingEvent()
